import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const useInfiniteScroll = (callback: () => Promise<void>, hasMore: boolean) => {
  const { ref, inView } = useInView({
    rootMargin: '0px 0px 300px 0px',
  });

  useEffect(() => {
    if (inView && hasMore) {
      callback();
    }
  }, [inView, hasMore, callback]);

  return ref;
};

export default useInfiniteScroll;
